import { poTotalJmd } from './purchaseOrders';

// What a vendor record should answer, derived from purchase orders you've
// already raised. None of this needs storing — deriving it means it can't
// drift from the orders it describes.

function daysBetween(from, to) {
  const a = new Date(`${from}T00:00:00`);
  const b = new Date(`${to}T00:00:00`);
  return Math.round((b - a) / 86_400_000);
}

export function vendorStats(vendor, orders) {
  const relevant = (orders || []).filter((o) => o.status !== 'Cancelled');
  const received = relevant.filter((o) => o.status === 'Received' && o.actual_delivery_date);

  const deliveryDays = received
    .map((o) => daysBetween(o.order_date, o.actual_delivery_date))
    .filter((d) => Number.isFinite(d) && d >= 0);

  const actualLeadTime = deliveryDays.length
    ? Math.round(deliveryDays.reduce((s, d) => s + d, 0) / deliveryDays.length)
    : null;

  const lastOrder = relevant
    .map((o) => o.order_date)
    .sort()
    .pop();

  return {
    orderCount: relevant.length,
    // poTotalJmd takes (items, rate) — the order carries both.
    totalSpendJmd: relevant.reduce(
      (sum, o) => sum + poTotalJmd(o.purchase_order_items || [], o.exchange_rate),
      0
    ),
    // What they claim versus what actually happened. The gap is the useful
    // part — you only learn it from your own order history.
    statedLeadTime: vendor.lead_time_days ?? null,
    actualLeadTime,
    deliveriesMeasured: deliveryDays.length,
    lastOrderDate: lastOrder || null,
    openOrders: relevant.filter((o) => o.status === 'Ordered' || o.status === 'Shipped').length,
  };
}
